<app-frame>
  <router-outlet></router-outlet>
</app-frame>
